module.exports = __webpack_public_path__ + "media/images/flags/16/Macedonia-e04f770a61c57a38cdcac3881fbe01cd.png";